import { useTranslation } from 'react-i18next'

import { ICON_HEIGHT_72, IconNG } from '../../Icon'
import Text from '../../Text'

import * as styles from './EmailGoogleTemplateEmpty.module.css'

import TemplateIcon from '../../../icons/template.svg'

function EmailGoogleTemplateEmpty() {
  const { t } = useTranslation()

  return (
    <div className={styles.empty}>
      <IconNG Icon={TemplateIcon} size={ICON_HEIGHT_72} />
      <Text isSecondary>{t('Emails.SelectGoogleTemplatePlaceholderKey')}</Text>
    </div>
  )
}

export default EmailGoogleTemplateEmpty
